'use strict'

import 'svgxuse'
import $ from 'jquery'
import app from 'app'
import stacktable from 'stacktable.js'
import "core-js/fn/array/find"
import "core-js/fn/array/from"
import "core-js/fn/map"
import "core-js/fn/object/assign"
import "core-js/fn/promise"
import "core-js/fn/set"
import "element-closest"
import "mutation-observer-inner-html-shim"
import { Application } from "stimulus"
import { autoload } from "stimulus/webpack-helpers"
import { Foundation } from 'foundation-sites/js/foundation.core'
import { Orbit } from 'foundation-sites/js/foundation.orbit.js'
import { Accordion } from 'foundation-sites/js/foundation.accordion.js'
import { AccordionMenu } from 'foundation-sites/js/foundation.accordionMenu.js'
// import { OffCanvas } from 'foundation-sites/js/foundation.offcanvas'

// setup stimulus
const application = Application.start()
const controllers = require.context("./controllers", true, /\.js$/)
autoload(controllers, application)

window.$ = $
window.jQuery = $

// Require non-modular scripts
require('motion-ui');
require('what-input');

// Set up foundation plugins
Foundation.addToJquery(jQuery);

Foundation.plugin(Orbit, 'Orbit');
Foundation.plugin(Accordion, 'Accordion');
Foundation.plugin(AccordionMenu, 'AccordionMenu');

window.site = {
    init() {
        $('[href*=".pdf"]').attr('target','_blank')
        $('.stacktable.stackstandard').stacktable()
        $('.stacktable.stackcolumns').stackcolumns()


        if ($('.master').hasClass('v-course-section')) {
            // start watching time spent on section
            const timeStart = new Date()

            $('a').on('click', function(e) {
                if (this.getAttribute('target') === '_blank') {
                    return
                }

                e.preventDefault()
                const destination = this.href
                const timeEnd = new Date()
                let completed = true
                let skipNavigation = false

                if (this.getAttribute('href') === '#') {
                    skipNavigation = true
                }
        

                if ($('.button--advance').hasClass('disabled')) {
                    completed = false
                }
       
                app.jsonRequest('website', {mode: 'progress_tracking'}, {
                    type: 'POST',
                    data: {
                        completed: completed,
                        location: window.location.pathname,
                        timeSpent: timeEnd - timeStart,
                    },
                    success(data, status) {
                        console.log(data, status)
                    },
                    complete() {
                        if (skipNavigation) {
                            return
                        }
                        window.location.href = destination
                    }
                })
            })
        }

        // just rejigger the Orbit when in an accordion I guess
        $('.accordion.question__review').on('down.zf.accordion', function(e) {
            const brokenOrbits = $(e.target).find('.orbit')
            Foundation.reInit(brokenOrbits)
        })
    }
}

// make all the foundation jquery handler things happen
$(document).foundation()

$(function() {
    site.init()
});
